import CommonActions from '../actions/actions';
import { fbOauthTokensCRUDActions as actions } from '../actions/FBOauthTokensCRUDActions';
import { FBOauthTokensState } from '../interfaces/FBOauthTokens';
import { FBOauthTokenModel } from '../model/FBOauthTokenModel';

type ActionRetrivedAll = {
  type: string;
  entities: FBOauthTokenModel[];
};

type ActionRetrived = {
  type: string;
  entity: FBOauthTokenModel;
};

type ActionType = ActionRetrivedAll & ActionRetrived;

const initialState: FBOauthTokensState = {
  busy: false,
  loaded: false,
  entities: [],
};

export const fbOauthTokens = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case actions.busyAction:
      return { ...state, busy: true };
    case actions.retrievedAllAction: {
      return {
        ...state,
        busy: false,
        entities: action.entities || [],
        loaded: true,
      };
    }
    case actions.retrievedAction: {
      return { ...state, entities: [...state.entities, action.entity] };
    }
    case actions.unbusyAction:
      return { ...state, busy: false };
    case actions.deleteAction:
      return { ...state, entities: [] };
    case CommonActions.RESET:
    case CommonActions.RESET_COMPANY:
      return { ...initialState };
    default:
      return state;
  }
};
